import { ComponentStyleConfig } from '@chakra-ui/react';

export const NotFoundPage: ComponentStyleConfig = {
  parts: ['container', 'title', 'subtitle'],
  baseStyle: ({ isMobile }) => ({
    container: {
      mt: isMobile ? '64px' : 0,
      justifyContent: 'center',
      alignItems: 'center',
    },
    title: {
      fontWeight: 600,
      fontSize: 'xl',
      mt: 6,
    },
    subtitle: {
      color: 'textSubdued',
      fontSize: 'md',
      textAlign: 'center',
      mt: 1,
      width: 'full',
      maxWidth: 536,
    },
  }),
  variants: {},
  defaultProps: {},
};
